import { Box, Typography } from '@mui/material';
import { parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { Api } from '../../api';

interface AppointmentCardProps {
  appointment: Api.Appointment.V_ClinicianSub;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  style?: React.CSSProperties;
  timezone: string;
}

export default function AppointmentCard({
  appointment,
  onClick,
  style,
  timezone,
}: AppointmentCardProps) {
  return (
    <Box
      onClick={onClick}
      sx={{
        backgroundColor: 'background.paper',
        py: '2px',
        px: '8px',
        borderRadius: '8px',
        borderLeft: '4px solid',
        borderLeftColor: 'primary.main',
        boxShadow: 1,
        cursor: 'pointer',
        position: 'absolute',
        left: '10px',
        right: '10px',
        display: 'flex',
        alignItems: 'center',
        '&:hover': { boxShadow: 2 },
        ...style,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontWeight: 500,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {formatInTimeZone(parseISO(appointment.startAt), timezone, 'HH:mm')}{' '}
        {appointment.user.name || appointment.user.id}
      </Typography>
    </Box>
  );
}
